var system = {
    maxFileUploadSize: 2097152, // 2 MB
    euro: 'EUR',                // The euro currency
};


export default system;


